import Vue from "vue";

const success = (response, context) => {
  response.data.listings.forEach((listing) => {
    context.listings.push({
      id: listing.id,
      name: listing.name,
      choice: listing.choice,
      rental_exists: listing.rental_exists,
      rental_name: listing.rental_name,
    });
  });
};

export default (context) => {
  let url = `/airbnb/listings`;
  if (context.currentAibnbAccountId) {
    url += `?airbnb_account_id=${context.currentAibnbAccountId}`;
  }
  return Vue.$http
    .get(url)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      context.error = error.response.data.msg
        ? error.response.data.msg
        : error.message;
      console.log(error, "[GET] /airbnb/listings error");
    })
    .finally(() => {
      console.log("finally", "[GET] /airbnb/listings");
    });
};



// WEBPACK FOOTER //
// ./src/app/services/airbnb/get-listings.js